import Quiz from './quizzes.js';

export default {
    'QuizBuilder/AUTO_SAVE_QUIZ': {
        fields: ['title', 'questions_per_page', 'random_question_order', 'must_answer_in_order', 'calculator_enabled'],
        callback: async (store, mutation) => {
            const helper = new Quiz(store, mutation);

            await helper.save({ type: 'quiz' });
        },
    },

    'QuizBuilder/AUTO_SAVE_QUESTION': {
        fields: [
            'body',
            'random_answer_order',
            'required',
            'is_repetitive',
            'minimum_word_count',
            'partial_credit',
            'points',
        ],
        callback: async (store, mutation) => {
            const helper = new Quiz(store, mutation);

            await helper.save({ type: 'question' });
        },
    },

    'QuizBuilder/AUTO_SAVE_ANSWER': {
        fields: ['body', 'value', 'is_correct', 'rationale'],
        callback: async (store, mutation) => {
            const helper = new Quiz(store, mutation);

            await helper.save({ type: 'answer' });
        },
    },

    // 'QuizBuilder/AUTO_SAVE_REMOVE': {
    //     fields: ['remove'],
    //     callback: async (store, mutation) => {
    //         console.log('testing');
    //
    //         const helper = new Quiz(store, mutation);
    //
    //         await helper.delete();
    //     }
    // },

    'QuizBuilder/AUTO_SAVE_REORDER': {
        fields: ['order', 'display_order'],
        callback: async (store, mutation) => {
            const helper = new Quiz(store, mutation);

            await helper.save({ type: 'reorder' });
        },
    },
};
